import { esc } from '@/utils/escape';

export function generateTeamHTML(data: any, settings: any): string {
  const members = (data.members || [])
    .map(
      (m: any) => `        <div class="team-member">
          <div class="team-member__image">
            ${m.image ? `<img src="${esc(m.image)}" alt="${esc(m.name)}" loading="lazy">` : `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>`}
          </div>
          <h4>${esc(m.name)}</h4>
          <p class="team-member__role">${esc(m.role)}</p>
          ${m.bio ? `<p class="team-member__bio">${esc(m.bio)}</p>` : ""}
        </div>`,
    )
    .join("\n");

  return `  <!-- Team -->
  <section class="team" id="team">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
        <p>${esc(data.subtitle)}</p>
      </div>
      <div class="team__grid">
${members}
      </div>
    </div>
  </section>`;
}
